import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface GoogleAdsBannerProps {
  adSlot?: string;
  adClient?: string;
}

export function GoogleAdsBanner({
  adSlot = 'YOUR_AD_SLOT_ID',
  adClient = 'ca-pub-YOUR_PUBLISHER_ID'
}: GoogleAdsBannerProps) {
  const { user } = useAuth();
  const [tenantTier, setTenantTier] = useState<string | null>(null);
  const [isAdBlockerDetected, setIsAdBlockerDetected] = useState(false);

  useEffect(() => {
    if (user) {
      checkTenantTier();
    }
  }, [user]);

  useEffect(() => {
    detectAdBlocker();
  }, []);

  const checkTenantTier = async () => {

    const { data: userTenants } = await supabase
      .from('user_tenants')
      .select('tenant_id')
      .eq('user_id', user?.id)
      .limit(1)
      .maybeSingle();

    if (userTenants) {
      const { data: tenant } = await supabase
        .from('tenants')
        .select('subscription_tier')
        .eq('id', userTenants.tenant_id)
        .maybeSingle();

      if (tenant) {
        setTenantTier(tenant.subscription_tier);
      }
    }
  };

  const detectAdBlocker = () => {
    const testAd = document.createElement('div');
    testAd.innerHTML = '&nbsp;';
    testAd.className = 'adsbox';
    testAd.style.position = 'absolute';
    testAd.style.top = '-1px';
    testAd.style.left = '-1px';
    testAd.style.width = '1px';
    testAd.style.height = '1px';
    document.body.appendChild(testAd);

    setTimeout(() => {
      const isBlocked = testAd.offsetHeight === 0;
      setIsAdBlockerDetected(isBlocked);
      document.body.removeChild(testAd);
    }, 100);
  };

  if (!user || tenantTier === null) {
    return null;
  }

  if (tenantTier !== 'trial') {
    return null;
  }

  if (isAdBlockerDetected) {
    return (
      <div className="glass-panel m-4 p-4 text-center">
        <p className="text-sm text-white/60">
          Support AI F&B by disabling your ad blocker or{' '}
          <a href="/settings" className="text-primary-400 hover:text-primary-300 underline">
            upgrade to a paid plan
          </a>
        </p>
      </div>
    );
  }

  return (
    <div className="glass-panel m-4 p-4">
      <div className="text-center mb-2">
        <span className="text-xs text-white/40 uppercase tracking-wider">Advertisement</span>
      </div>

      <div className="flex items-center justify-center min-h-[90px] bg-white/5 rounded-lg border border-white/10">
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client={adClient}
          data-ad-slot={adSlot}
          data-ad-format="horizontal"
          data-full-width-responsive="true"
        />
      </div>

      <div className="text-center mt-2">
        <p className="text-xs text-white/40">
          Remove ads by{' '}
          <a href="/settings" className="text-primary-400 hover:text-primary-300 underline">
            upgrading your plan
          </a>
        </p>
      </div>
    </div>
  );
}
